document.addEventListener("click", (event) => {
  const link = event.target.closest("a[href^='#']");
  if (!link) return;

  const id = link.getAttribute("href").slice(1);
  const container = document.getElementById(id);
  if (!container?.classList.contains("product__block--collapsible_tab")) return;

  const details = container.querySelector("details");
  if (details && !details.open) {
    details.open = true;
    details.querySelector("summary")?.focus({ preventScroll: true });
  }
});

function toggleVariantElements(variantId = null) {
  const elements = document.querySelectorAll("*[data-variant-elements-toggle]");

  elements.forEach((element) => {
    const elementVariantId = element.getAttribute("data-variant-id");
    const shouldShow = variantId && elementVariantId === String(variantId);
    element.classList.toggle("hidden", !shouldShow);
  });
}

document.addEventListener('variant:changed', (event) => {
    let variant = event.detail.variant;
    toggleVariantElements(variant.id);
})

function initProductCounter() {
  const productList = document.getElementById("ProductsList");
  const productCount = document.getElementById("ProductCount");

  if (!productList || !productCount) {
    return;
  }

  if (typeof productList._productCounterCleanup === "function") {
    try {
      productList._productCounterCleanup();
    } catch {}
  }

  let lastRenderedCount = null;

  const parseFirstInteger = (value) => {
    if (value == null) {
      return null;
    }

    // Regex: get only integers from string
    const cleaned = String(value).replace(/[^0-9]/g, "");
    if (!cleaned) {
      return null;
    }
    const integer = parseInt(cleaned, 10);
    return Number.isFinite(integer) ? integer : null;
  };

  const collectCountCandidates = (listElelement, countElelement) => {
    const candidates = [
      countElelement.getAttribute("data-product-count"),
      countElelement.getAttribute("data-count"),
      countElelement.getAttribute("data-total"),
      listElelement.getAttribute("data-product-count"),
      listElelement.getAttribute("data-count"),
      listElelement.getAttribute("data-total"),
      listElelement.dataset?.productCount,
      listElelement.dataset?.count,
      listElelement.dataset?.total,
    ];

    return candidates.filter((candidate) => candidate != null && String(candidate).trim() !== "");
  };

  const countUniqueProductHandles = (listElelement) => {
    const anchors = Array.from(listElelement.querySelectorAll("a[href*='/products/']"));
    const handles = new Set();

    for (const anchor of anchors) {
      const href = anchor.getAttribute("href");
      if (!href) continue;

      try {
        const url = new URL(href, window.location.origin);
        const match = url.pathname.match(/\/products\/([^/]+)/);
        if (match && match[1]) handles.add(match[1]);
      } catch {}
    }

    return handles.size;
  };

  const countVisibleTiles = (listElelement) => {
    const tiles = Array.from(
      listElelement.querySelectorAll("li, .grid__item, .product-card, .product-grid-item"),
    );

    const visibleTiles = tiles.filter((element) => {
      if (!(element instanceof HTMLElement)) {
        return false;
      }

      const style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden") {
        return false;
      }

      if (element.querySelector("a[href*='/products/']")) {
        return true;
      }
      return (element.textContent || "").trim().length > 0;
    });

    return visibleTiles.length;
  };

  const getCurrentItemCount = () => {
    const listElelement = document.getElementById("ProductsList");
    const countElelement = document.getElementById("ProductCount");
    if (!listElelement || !countElelement) {
      return null;
    }

    const candidates = collectCountCandidates(listElelement, countElelement);
    for (const candidate of candidates) {
      const integer = parseFirstInteger(candidate);
      if (integer != null) {
        return integer;
      }
    }

    const byHandles = countUniqueProductHandles(listElelement);
    if (byHandles) {
      return byHandles;
    }

    const byTiles = countVisibleTiles(listElelement);
    return byTiles || 0;
  };

  const updateCountText = (countElelement, newCount) => {
    const numberNode = countElelement.querySelector(
      "[data-count], .count, .product-count, .js-product-count",
    );

    if (numberNode) {
      numberNode.textContent = String(newCount);
      return;
    }

    const oldText = countElelement.textContent || countElelement.innerText || "";

    // Regex: check if exatly one digit is present
    if (/\d/.test(oldText)) {
      // Regex: match a number starting with a digit, followed by digits, dots or commas (e.g. 1, 1.234, 12,34)
      let updatedText = oldText.replace(/\d[\d.,]*/u, String(newCount));

      // Regex: ensure a space after the number if the next character is not whitespace or part of a number
      updatedText = updatedText.replace(/(\d[\d.,]*)(?=[^\s\d.,])/u, "$1 ");

      countElelement.textContent = updatedText;
      return;
    }

    countElelement.textContent = String(newCount);
  };

  const onProductsUpdated = () => {
    const countElelement = document.getElementById("ProductCount");
    if (!countElelement) return;

    const currentItemCount = getCurrentItemCount();
    if (currentItemCount == null || !Number.isFinite(currentItemCount)) return;

    if (lastRenderedCount === currentItemCount) return;
    lastRenderedCount = currentItemCount;

    updateCountText(countElelement, currentItemCount);
  };

  let rafId = null;
  let timeoutId = null;

  const scheduleCountUpdate = () => {
    if (rafId) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      onProductsUpdated();

      if (timeoutId) window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        timeoutId = null;
        onProductsUpdated();
      }, 150);
    });
  };

  const listObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type !== "childList") continue;
      if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
        scheduleCountUpdate();
        break;
      }
    }
  });

  listObserver.observe(productList, {
    childList: true,
    subtree: true,
  });

  const countObserver = new MutationObserver(() => scheduleCountUpdate());
  countObserver.observe(productCount, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  productList._productCounterCleanup = () => {
    listObserver.disconnect();
    countObserver.disconnect();
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    if (timeoutId) window.clearTimeout(timeoutId);
    timeoutId = null;
  };

  onProductsUpdated();
}

document.addEventListener("DOMContentLoaded", () => {
  initProductCounter();

  const sectionObserver = new MutationObserver((mutationsList) => {
    let shouldInit = false;

    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        const isProductsList =
          node.id === "ProductsList" || (node.querySelector && node.querySelector("#ProductsList"));

        const isProductCount =
          node.id === "ProductCount" || (node.querySelector && node.querySelector("#ProductCount"));

        if (isProductsList || isProductCount) {
          shouldInit = true;
        }
      }
    }

    if (shouldInit) {
      initProductCounter();
    }
  });

  sectionObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

function fitTextToCircle(element, { maxSize = 40, minSize = 20 } = {}) {
  let currentFontSize = maxSize;
  const elementWidth = element.clientWidth;
  const elementHeight = element.clientHeight;
  if (!elementWidth || !elementHeight) return null;

  element.style.fontSize = currentFontSize + "px";

  while (
    (element.scrollWidth > elementWidth || element.scrollHeight > elementHeight) &&
    currentFontSize > minSize
  ) {
    currentFontSize -= 1;
    element.style.fontSize = currentFontSize + "px";
  }

  return element.style.fontSize;
}

function fitBadgeTextToCircle(badgeElement, textOptions) {
  const fontSize = fitTextToCircle(badgeElement, textOptions);
  if (fontSize) return;

  const clone = badgeElement.cloneNode(true);
  clone.style.visibility = "hidden";
  clone.style.position = "absolute";
  clone.style.top = "-9999px";
  clone.style.left = "-9999px";
  clone.style.pointerEvents = "none";
  document.body.appendChild(clone);

  const cloneFontSize = fitTextToCircle(clone, textOptions);
  if (cloneFontSize) {
    badgeElement.style.fontSize = cloneFontSize;
  }

  clone.remove();
}

function adjustBadgesTextSize(rootElement = document, textOptions = { maxSize: 25, minSize: 14 }) {
  const badgeSelector = ".f-badge-shape--rund";
  rootElement.querySelectorAll(badgeSelector).forEach((badgeElement) => {
    fitBadgeTextToCircle(badgeElement, textOptions);
  });
}

document.addEventListener("DOMContentLoaded", () => adjustBadgesTextSize());

function onProductRecommendationsReady(callback) {
  const executeCallback = (element) => callback(element);
  let productRecommendationsElement = document.querySelector("product-recommendations");

  if (productRecommendationsElement) {
    observeChanges(productRecommendationsElement, executeCallback);
  }

  const creationObserver = new MutationObserver(() => {
    productRecommendationsElement = document.querySelector("product-recommendations");
    if (productRecommendationsElement) {
      observeChanges(productRecommendationsElement, executeCallback);
    }
  });

  creationObserver.observe(document.body, { childList: true, subtree: true });
}

function observeChanges(element, callback) {
  callback(element);

  const innerObserver = new MutationObserver(() => callback(element));
  innerObserver.observe(element, { childList: true, subtree: true });
}

onProductRecommendationsReady((rootElement) => {
  const relatedProductsRoot = rootElement.querySelector(".related-products") || rootElement;

  adjustBadgesTextSize(relatedProductsRoot);
});

(function () {
  function getPandectesWidget() {
    const host = document.querySelector("pandectes-a11y");
    return host?.shadowRoot?.querySelector("button.widget") ?? null;
  }

  function syncPandectesA11yPosition() {
    if (!document.body.classList.contains("product-template")) return;

    const widget = getPandectesWidget();
    const backToTop = document.querySelector(".back-to-top");
    if (!widget || !backToTop) return;

    const bottom = getComputedStyle(backToTop).bottom;
    if (bottom && bottom !== "auto") {
      widget.style.setProperty("bottom", bottom, "important");
    }
  }

  function observeElement(el, observer) {
    if (el instanceof Element) observer.observe(el);
  }

  function initPandectesA11ySync() {
    syncPandectesA11yPosition();

    window.addEventListener("resize", syncPandectesA11yPosition);
    window.addEventListener("scroll", syncPandectesA11yPosition, { passive: true });

    const resizeObserver = new ResizeObserver(syncPandectesA11yPosition);
    ["sticky-atc-bar", "mobile-sticky-bar", ".back-to-top", "pandectes-a11y"].forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => observeElement(el, resizeObserver));
    });

    const mutationObserver = new MutationObserver(() => {
      syncPandectesA11yPosition();
      document.querySelectorAll("sticky-atc-bar, mobile-sticky-bar, pandectes-a11y").forEach((el) => {
        observeElement(el, resizeObserver);
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    mutationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPandectesA11ySync);
  } else {
    initPandectesA11ySync();
  }
})();

/* BCS-213 Accordion Group Scroll Fix */

(function initAccordionGroupScroll() {
  if (!document.body?.classList.contains("product-template")) return;

  let pendingScrollSummary = null;

  function isAccordionGroup(details) {
    return details?.getAttribute?.("is") === "accordion-group";
  }

  let activeScrollFrame = null;

  function getSummaryScrollTarget(summary) {
    const headerOffset =
      parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const top = summary.getBoundingClientRect().top;
    return Math.max(0, window.scrollY + top - headerOffset);
  }

  function scrollSummaryIntoView(summary) {
    if (!summary?.isConnected) return;

    if (activeScrollFrame) {
      cancelAnimationFrame(activeScrollFrame);
      activeScrollFrame = null;
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      window.scrollTo(0, getSummaryScrollTarget(summary));
      return;
    }

    const maxDuration = 500;
    const startTime = performance.now();

    function step(now) {
      if (!summary.isConnected) {
        activeScrollFrame = null;
        return;
      }

      const target = getSummaryScrollTarget(summary);
      const delta = target - window.scrollY;

      if (Math.abs(delta) < 1 || now - startTime > maxDuration) {
        window.scrollTo(0, getSummaryScrollTarget(summary));
        activeScrollFrame = null;
        return;
      }

      window.scrollTo(0, window.scrollY + delta * 0.18);
      activeScrollFrame = requestAnimationFrame(step);
    }

    activeScrollFrame = requestAnimationFrame(step);
  }

  function hasAnimatingSibling(details) {
    const parent = details.closest(".accordion-parent") || document;

    return [...parent.querySelectorAll('details[is="accordion-group"]')].some(
      (item) => item !== details && item.style.overflow === "hidden"
    );
  }

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.button !== 0) return;

      const summary = event.target.closest("summary");
      if (!summary) return;

      const details = summary.closest("details");
      if (!isAccordionGroup(details) || details.open) return;

      pendingScrollSummary = summary;
    },
    true
  );

  function patchAccordionGroup() {
    const AccordionGroup = customElements.get("accordion-group");
    if (!AccordionGroup) return;

    const originalHandleAfterAnimated = AccordionGroup.prototype.handleAfterAnimated;

    AccordionGroup.prototype.handleAfterAnimated = function handleAfterAnimatedWithScroll() {
      if (typeof originalHandleAfterAnimated === "function") {
        originalHandleAfterAnimated.call(this);
      }

      if (!pendingScrollSummary) return;

      const targetDetails = pendingScrollSummary.closest("details");
      if (!isAccordionGroup(targetDetails) || !targetDetails.open) {
        pendingScrollSummary = null;
        return;
      }

      if (!this.isOpen && this !== targetDetails) {
        scrollSummaryIntoView(pendingScrollSummary);
        pendingScrollSummary = null;
        return;
      }

      if (
        this.isOpen &&
        this.summaryElement === pendingScrollSummary &&
        !hasAnimatingSibling(this)
      ) {
        scrollSummaryIntoView(pendingScrollSummary);
        pendingScrollSummary = null;
      }
    };
  }

  if (customElements.get("accordion-group")) {
    patchAccordionGroup();
  } else {
    customElements.whenDefined("accordion-group").then(patchAccordionGroup);
  }
})();
